export default {"src":"/_next/static/media/admin-read-convos.88fd3d31.svg","height":24,"width":27,"blurWidth":0,"blurHeight":0};